import styled from "@emotion/styled";
import { FC, useCallback, useEffect, useState } from "react";
import { Bread } from "../../common/component/Bread";
import { ImageFill } from "../../common/component/ImageFill";
import { ImgCard } from "../../common/component/ImgCard";
import { IndustryEntity } from "../../module/industry/entity/industry.entity";
import { getIndustryList } from "../../module/industry/service/industry.service";

const breadArr = [
	{
		title: "行业相关"
	}
]

export const IndustryList: FC = () => {
	const [data, setData] = useState<IndustryEntity[]>([]);

	const init = useCallback(async () => {
		const { data } = await getIndustryList();
		setData(data);
	}, []);

	useEffect(() => {
		window.scrollTo(0, 0);
		init();
	}, [init]);

	return (
		<Container>
			<ImageFill src={"https://splashtest.oss-cn-shanghai.aliyuncs.com/img1/products.jpg"} width={1600} height={500} areaHeight={296} />
			<div className='content'>
				<div className='page-title'>
					<h1>行业相关</h1>
				</div>
				<Bread value={breadArr} />

				<div className='inner-description'>
					<h2>行业的发展离不开我们的推动!</h2>
					<br />
					<h3>道路施工、炼油厂、农业技术、水泥工业……</h3>
					<div style={{textIndent: '1rem'}}>Optibelt 根据产品所应用的各个行业对产品提出不同的要求。从用于农业机械设备的牢固的联组带，到用于道路施工的高效 V 型带以及用于纺织行业的精密同步带，Optibelt 产品应用广泛，可满足不同行业的应用需求。</div>
				</div>
				<div className='card-list'>
					{data &&
						data.map((item) => {
							return <ImgCard key={item.id} className='item col-lg-3 col-md-6 col-xs-12' img={item.image??""} linkTitle={item.title??""} url={"/industry/" + item.id} />;
						})}
				</div>
			</div>
		</Container>
	);
};
const Container = styled.div`
	width: 100%;

	.content {
		margin: -7em auto 0;
		background: white;
		padding: 1em;
		z-index: 10;
		position: relative;

		.inner-description {
			margin: 0 15px;
		}

		.card-list {
			display: flex;
			flex-wrap: wrap;
			justify-content: left;
			margin-top: 1rem;

			.item {
				margin: 1rem 1rem 0;
			}
		}
	}
`;
